import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Table } from "../../Component/Table/Table";
import { URLS } from "../../Services/Constant";
import { get, post as postApi } from "../../Services/ApiHandler";
import Footer from "../../Component/Footer/Footer";
import { Toast } from "../../Component/Toast";
import useStoreKv from "../redux/store/useStorekv";
import CustomScroll from "../../Component/CustomScroll";

const LotPrice = () => {
  const navigate = useNavigate();

  const { kv, set } = useStoreKv();
  const lotDear = kv.lotdear || [];
  const lotKerala = kv.lotkerala || [];

  const [owners, setOwners] = useState(lotDear);
  const [kerala, setKerala] = useState(lotKerala);
  const [pagination, setPagination] = useState("");
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [popup, setPopup] = useState(false);
  const [loadingId, setLoadingId] = useState(null);
  const [loadingType, setLoadingType] = useState(null);
  const [loadingAction, setLoadingAction] = useState(null); // "update" or "status"
  const [updateItem, setUpdateItem] = useState(null);
  const [updateType, setUpdateType] = useState(null);
  const [updateAction, setUpdateAction] = useState(null);

  /** Fetch lot price list */
  const getList = async () => {
    try {
      if (!kv.lotdear || kv.lotdear.length === 0) {
        setLoading(true);
      }
      const res = await get(`${URLS.LOTPRICELIST}`);

      if (res?.status === "success" && Array.isArray(res?.data)) {
        setOwners(res?.data[0]?.lots || []);
        setKerala(res?.data[1]?.lots || []);
        set("lotdear", res?.data[0]?.lots || []);
        set("lotkerala", res?.data[1]?.lots || []);
      } else {
        Toast("Invalid data format received");
        setOwners([]);
        setKerala([]);
        set("lotdear", []);
        set("lotkerala", []);
      }
    } catch (err) {
      Toast("Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  /** Update Status or Price */
  const handleUpdate = async (row, type, actionType) => {
    setLoading1(true);
    setLoadingId(row?.id);
    setLoadingType(type);
    setLoadingAction(actionType); // <-- FIX ADDED

    let updatedStatus =
      actionType === "delete" ? (row.status === 1 ? 0 : 1) : row.status;

    const payload = {
      name: row?.name,
      client_price: row?.client_price,
      status: updatedStatus,
      group_type: type === "dear" ? "Dear" : "Kerala",
      fee_price_id: row?.fee_price_id,
    };

    try {
      const res = await postApi(`${URLS.LOTPRICEUPDATE}`, payload);

      if (res?.status === "success") {
        Toast("Updated successfully!");
        await getList();
      } else {
        Toast(res?.message || "Update failed");
      }
    } catch (err) {
      Toast("Failed to update price");
    } finally {
      setLoading1(false);
      setLoadingId(null);
      setLoadingType(null);
      setLoadingAction(null);
    }
  };

  /** Shared columns */
  const getColumns = (list, setList, type) => [
    {
      Header: "Lot Group",
      accessor: "name",
      Cell: ({ row }) => {
        const handleChange = (e) => {
          const updated = [...list];
          updated[row.index] = {
            ...updated[row.index],
            name: e.target.value,
          };
          setList(updated);
        };
        return (
          <div style={{ width: 150, alignSelf: "center" }}>
            <input
              type="text"
              defaultValue={row.original.name}
              onBlur={(e) => handleChange(e)}
              className="form-control6 text-center placholdercolorchanges2"
              placeholder="Enter group name"
            />
          </div>
        );
      },
    },

    {
      Header: "Client Price",
      accessor: "client_price",
      Cell: ({ row }) => {
        const handleChange = (e) => {
          const updated = [...list];
          updated[row.index] = {
            ...updated[row.index],
            client_price: e.target.value,
          };
          setList(updated);
        };
        return (
          <div style={{ alignSelf: "center" }}>
            <input
              type="number"
              min="0"
              defaultValue={row.original.client_price}
              onBlur={(e) => handleChange(e)}
              className="form-control6 text-center placholdercolorchanges2"
              placeholder="Enter price"
            />
          </div>
        );
      },
    },

    {
      Header: "Status",
      accessor: "status",
      Cell: ({ row }) => (
        <div className="d-flex ac-jc">
          <button
            onClick={() => {
              setUpdateItem(row.original);
              setUpdateType(type);
              setUpdateAction("delete");
              setPopup(true);
            }}
            className={`${list[row.index]?.status === 0 ? "deactive-icon1" : "active-icon1"
              } f2 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-12 fs-xl-12 fs-xxl-13`}
          >
            {loadingId === row.original?.id &&
              loadingType === type &&
              loadingAction === "delete" ? (
              <span
                className="spinner-border spinner-border-sm"
                style={{ color: "white", width: 10, height: 10 }}
              ></span>
            ) : list[row.index]?.status === 0 ? (
              "Deactive"
            ) : (
              "Active"
            )}
          </button>
        </div>
      ),
    },

    {
      Header: "Action",
      accessor: "action",
      Cell: ({ row }) => (
        <div className="d-flex ac-jc">
          <button
            className="update-btn f2 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-12 fs-xl-12 fs-xxl-13"
            onClick={() => {
              setUpdateItem(row.original);
              setUpdateType(type);
              setUpdateAction("update");
              setPopup(true);
            }}
          >
            {loadingId === row.original?.id &&
              loadingType === type &&
              loadingAction === "update" ? (
              <span
                className="spinner-border spinner-border-sm"
                style={{ color: "white", width: 10, height: 10 }}
              ></span>
            ) : (
              "Update"
            )}
          </button>
        </div>
      ),
    },
  ];

  /** Memoized Columns */
  const dearColumns = useMemo(
    () => getColumns(owners, setOwners, "dear"),
    [owners, loadingId, loadingType, loadingAction]
  );

  const keralaColumns = useMemo(
    () => getColumns(kerala, setKerala, "kerala"),
    [kerala, loadingId, loadingType, loadingAction]
  );

  return (
    <div className="dashRightView d-flex ac-jb flex-column">
      <CustomScroll height="100vh">
        <div style={{ paddingTop: 0 }} className="container_overalls">
          {/* Dear Price List */}
          <div className="d-flex ac-js col-md-5 my-2">
            <label className="f3 fs-xs-17 fs-sm-14 fs-md-17 fs-lg-19 fs-xl-20 fs-xxl-22 primary">
              Dear Price List
            </label>
          </div>

          <Table
            columns={dearColumns}
            data={owners}
            pagecount={pagination}
            show={false}
            tableMargin={"25px"}
            // tableHeight={'66vh'}
            loading={loading}
          />

          {/* Kerala Price List */}
          <div className="d-flex ac-js col-md-5 my-2">
            <label className="f3 fs-xs-17 fs-sm-14 fs-md-17 fs-lg-19 fs-xl-20 fs-xxl-22 primary">
              Kerala Price List
            </label>
          </div>

          <Table
            columns={keralaColumns}
            data={kerala}
            pagecount={pagination}
            show={false}
            loading={loading}
          />
        </div>
        <Footer />
        {popup && (
          <div className="img-popup-design">
            <div className="img-popup">
              <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
                Are you sure you want to Update?
              </p>
              <div
                style={{ paddingTop: 20 }}
                className="d-flex ac-jb px-2  f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
              >
                <button onClick={() => setPopup(false)} className="no-btn w-40">
                  No
                </button>
                <button
                  onClick={async () => {
                    await handleUpdate(updateItem, updateType, updateAction);
                    setPopup(false);
                    setUpdateItem(null);
                    setUpdateType(null);
                    setUpdateAction(null);
                  }}
                  className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                >
                  {loading1 ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "white", padding: 8 }}
                      ></span>
                    </>
                  ) : (
                    <span style={{ top: -1.5, position: "relative" }}>Yes</span>
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
      </CustomScroll>
    </div>
  );
};

export default LotPrice;
